import { render } from "./ThemeToggle.vue?vue&type=template&id=05aa50c1&scoped=true"
import script from "./ThemeToggle.vue?vue&type=script&lang=js"
export * from "./ThemeToggle.vue?vue&type=script&lang=js"

import "./ThemeToggle.vue?vue&type=style&index=0&id=05aa50c1&scoped=true&lang=css"

import exportComponent from "/var/www/cmtycoin.xyz/repo/frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05aa50c1"]])

export default __exports__